import {useContext} from 'react'

import PropTypes from 'prop-types'

import AtomButton, {atomButtonDesigns, atomButtonShapes, atomButtonSizes} from '@s-ui/react-atom-button'
import AtomIcon, {ATOM_ICON_COLORS, ATOM_ICON_SIZES} from '@s-ui/react-atom-icon'
import Context from '@s-ui/react-context'
import {
  MoleculeDrawer,
  MoleculeDrawerOverlay,
  moleculeDrawerPlacements,
  moleculeDrawerSizes
} from '@s-ui/react-molecule-drawer'
import IconClose from '@adv-mt/mt-svg-icons/lib/Close'
import TitleBasic, {titleBasicSizes, titleBasicTags} from '@adv-mt/mt-title-basic'
import IconCircleCheckFilled from '@adv-mt/mt-svg-icons/lib/CircleCheckFilled'

const BASE_CLASS_NAME = 'mt-PublishMyAdWithPlate-stepSaleTypeSelection'

const IconCloseModal = () => (
  <AtomIcon as="button" size={ATOM_ICON_SIZES.medium}>
    <IconClose />
  </AtomIcon>
)

const COMPARISON_OPTIONS = {
  SELL_TO_PROFESSIONAL: [
    'SELLER_SELECTOR.HERO_SELECTOR.EXPERIMENT.INSTANT_OFFER.BULLET_SPEED',
    'SELLER_SELECTOR.HERO_SELECTOR.EXPERIMENT.INSTANT_OFFER.BULLET_PAYMENT_SECURITY',
    'SELLER_SELECTOR.HERO_SELECTOR.EXPERIMENT.INSTANT_OFFER.BULLET_NO_PAPERWORK',
    'SELLER_SELECTOR.HERO_SELECTOR.EXPERIMENT.INSTANT_OFFER.BULLET_NO_WARRANTY'
  ],

  PUBLISH_YOUR_AD: [
    'SELLER_SELECTOR.HERO_SELECTOR.EXPERIMENT.PUBLISH_AD.BULLET_TIME',
    'SELLER_SELECTOR.HERO_SELECTOR.EXPERIMENT.PUBLISH_AD.BULLET_POPULAR',
    'SELLER_SELECTOR.HERO_SELECTOR.EXPERIMENT.PUBLISH_AD.BULLET_NO_VISITS',
    'SELLER_SELECTOR.HERO_SELECTOR.EXPERIMENT.PUBLISH_AD.BULLET_WARRANTY'
  ]
}

const SaleTypeComparisonDrawer = ({isOpen, isWiderThanMobile, onClose}) => {
  const {i18n} = useContext(Context)

  return (
    <MoleculeDrawerOverlay isVisible={isOpen} onClick={onClose}>
      <MoleculeDrawer
        closeOnOutsideClick
        isOpen={isOpen}
        onClose={onClose}
        placement={moleculeDrawerPlacements.RIGHT}
        size={isWiderThanMobile ? moleculeDrawerSizes.AUTO : moleculeDrawerSizes.FILL}
      >
        <div className={`${BASE_CLASS_NAME}-drawerContent`}>
          <div className={`${BASE_CLASS_NAME}-drawerCloseButton`}>
            <AtomButton
              design={atomButtonDesigns.FLAT}
              leftIcon={<IconCloseModal />}
              onClick={onClose}
              shape={atomButtonShapes.CIRCULAR}
            />
          </div>
          <TitleBasic
            as={titleBasicTags.h2}
            size={titleBasicSizes.s}
            title="Vende tu coche online, fácil y rápido en coches.net"
          />
          <TitleBasic
            as={titleBasicTags.h3}
            size={titleBasicSizes.xs}
            title="Vende a un profesional si es tu primer coche en venta o buscas.."
          />

          <ul className={`${BASE_CLASS_NAME}-drawerList`}>
            {COMPARISON_OPTIONS.SELL_TO_PROFESSIONAL.map(label => (
              <li key={label} className={`${BASE_CLASS_NAME}-drawerListItem`}>
                <IconCircleCheckFilled
                  color={ATOM_ICON_COLORS.success}
                  size={ATOM_ICON_SIZES.medium}
                  role="presentation"
                  aria-hidden
                />
                {i18n.t(label)}
              </li>
            ))}
          </ul>
          <TitleBasic
            as={titleBasicTags.h3}
            size={titleBasicSizes.xs}
            title="Publica un anuncio si conoces el proceso de compraventa y..."
          />

          <ul className={`${BASE_CLASS_NAME}-drawerList`}>
            {COMPARISON_OPTIONS.PUBLISH_YOUR_AD.map(label => (
              <li key={label} className={`${BASE_CLASS_NAME}-drawerListItem`}>
                <IconCircleCheckFilled
                  color={ATOM_ICON_COLORS.success}
                  size={ATOM_ICON_SIZES.medium}
                  role="presentation"
                  aria-hidden
                />
                {i18n.t(label)}
              </li>
            ))}
          </ul>
          <AtomButton fullWidth onClick={onClose} shape={atomButtonShapes.CIRCULAR} size={atomButtonSizes.LARGE}>
            {i18n.t('COMMON.UNDERSTOOD')}
          </AtomButton>
        </div>
      </MoleculeDrawer>
    </MoleculeDrawerOverlay>
  )
}

SaleTypeComparisonDrawer.displayName = 'SaleTypeComparisonDrawer'

SaleTypeComparisonDrawer.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  isWiderThanMobile: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired
}

export default SaleTypeComparisonDrawer
